import { render, staticRenderFns } from "./Verbose.vue?vue&type=template&id=5167f8d0&"
import script from "./Verbose.vue?vue&type=script&lang=js&"
export * from "./Verbose.vue?vue&type=script&lang=js&"
import style0 from "./Verbose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports